import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(
    private http: HttpClient
  ) { }

  listDocuments(type: string) {

    const url = environment.API_URL + '/api/documents/list?type=' + type

    const TOKEN = CommonFunctions.getToken();

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  uploadDocument(type: string, file: File) {

  const url = environment.API_URL + '/api/documents/upload';

  const TOKEN = CommonFunctions.getToken();

  const httpOptions = {
    headers: new HttpHeaders({
      Authorization: 'Bearer ' + TOKEN,
    }),
  };

  const formData = new FormData();
  formData.append('type', type);
  formData.append('file', file, file.name);

  return this.http.post(url, formData, httpOptions).pipe(timeout(60000));
}

  deleteDocument(type: string) {

    const url = environment.API_URL + '/api/documents/remove/' + type

    const TOKEN = CommonFunctions.getToken();

    const body = {
      type: type
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post(url, body, httpOptions).pipe(timeout(60000));
  }

  getDocumentViewUrl(type: string) {
    const url = environment.API_URL + '/api/documents/view/' + type;

    const TOKEN = CommonFunctions.getToken();

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

}